import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=254576ae&scoped=true&"
import script from "./GroupPage.vue?vue&type=script&lang=js&"
export * from "./GroupPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupPage.vue?vue&type=style&index=0&id=254576ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254576ae",
  null
  
)

export default component.exports